import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/reducers";
import { IAccount } from "types/auth";

export interface IAuth {
  isSelectAccountLayout: boolean
  accountList?: IAccount[]
  emailVerify: string 
  emailResetPassword: string
  isHasActivate: boolean
  accessToken: string
}

const initialState: IAuth = {
  isSelectAccountLayout: false,
  accountList: [],
  emailVerify: '',
  emailResetPassword: '',
  accessToken: '',
  isHasActivate: false
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    toggleSignInLayout(state, action: PayloadAction<{ isSelectAccountLayout: boolean }>) {
      const { isSelectAccountLayout } = action.payload
      state.isSelectAccountLayout = isSelectAccountLayout
    },
    updateAccountList(state, action: PayloadAction<{ accounts: IAccount[] }>) {
      const { accounts } = action.payload
      state.accountList = accounts
    },
    updateEmailVerify(state, action: PayloadAction<{ email: string }>) {
      const { email } = action.payload
      state.emailVerify = email
    },
    updateEmailResetPassword(state, action: PayloadAction<{ email: string }>) {
      const { email } = action.payload
      state.emailResetPassword = email
    },
    updateLogin(state, action: PayloadAction<{ accessToken: string }>) {
      const { accessToken } = action.payload
      state.accessToken = accessToken
    },
    updateActivateAccount(state, action: PayloadAction<{ isHasActivate: boolean }>) {
      const { isHasActivate } = action.payload
      state.isHasActivate = isHasActivate
    }
  },
  extraReducers: {
    // Extra reducer comes here
  },
});
export const authSelector = (state: RootState) => state.auth;
export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;
export default authSlice.reducer;
